import { useToast } from "@chakra-ui/react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { useErrorToast } from "@/common/hooks/useErrorToast";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { Member, PatchMemberType } from "@reflag/shared/organizationAPI";

import { orgQueryKeys } from "./orgQueryKeys";

export function useMemberRoleUpdateMutation(memberId: string) {
  const toast = useToast();
  const queryClient = useQueryClient();
  const errorToast = useErrorToast();
  const { org } = useEnvironment();

  return useMutation<
    { member: Member },
    AxiosError<ErrorResponse>,
    PatchMemberType
  >({
    mutationKey: orgQueryKeys.member(org.id, memberId),

    mutationFn: ({ role }) =>
      api
        .patch<"/orgs/:orgId/members/:memberId">(
          `/orgs/${org.id}/members/${memberId}`,
          { role },
        )
        .then((res) => res.data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: orgQueryKeys.members(org.id),
      });

      toast({
        title: "Member role for organization updated",
        status: "success",
      });
    },

    onError: () => {
      errorToast({
        title: "Failed to update member role for organization",
      });
    },
  });
}
